import { CONTENT_KINDS, LIBRARY_KINDS, TEMPLATE_KINDS } from '../../../../../../shared/search/kinds'
import { IconCategory, IconCourse, IconLibrary, IconStreamingVideo, IconTemplate } from '../../../../../../shared/icon/icon'
import {
  buildContentCategoryPath,
  buildContentCoursePath,
  buildLibraryCategoryPath,
  buildLibraryPath,
  buildTemplateCategoryPath,
  buildTemplatePath
} from '../shared/build-path'

// What search is on each node area (spec 2026-10-09 §5.2-5.4): which
// datatypes it finds and what each is called, the type chips' words, the
// search box's placeholder, and where a result opens. One component
// (NodeSearchArea) serves all three.
//
// `href(nodes, node)` builds the page a result opens from the area's full
// list (the same paths the cards use).
export const CONTENT_SEARCH = {
  name: 'content',
  kinds: CONTENT_KINDS,
  rootLabel: 'Content',
  rootHref: '/org/node-content',
  folderHref: (nodes, id) => buildContentCategoryPath(nodes, id),
  placeholder: 'Search courses and folders',
  chips: { courses: 'Courses', folders: 'Folders' },
  noun: 'courses',
  platforms: true,
  icons: { Folder: IconCategory, Course: IconCourse, Video: IconStreamingVideo },
  href: (nodes, node) => (node.datatype === 'CATEGORY' ? buildContentCategoryPath(nodes, node.id) : buildContentCoursePath(nodes, node.id))
}

export const TEMPLATE_SEARCH = {
  name: 'templates',
  kinds: TEMPLATE_KINDS,
  rootLabel: 'Templates',
  rootHref: '/org/node-template',
  folderHref: (nodes, id) => buildTemplateCategoryPath(nodes, id),
  placeholder: 'Search templates and folders',
  chips: { courses: 'Templates', folders: 'Folders' },
  noun: 'templates',
  platforms: true,
  icons: { Folder: IconCategory, Template: IconTemplate },
  href: (nodes, node) =>
    node.datatype === 'COURSE_TEMPLATE_CATEGORY' ? buildTemplateCategoryPath(nodes, node.id) : buildTemplatePath(nodes, node.id)
}

export const LIBRARY_SEARCH = {
  name: 'library',
  kinds: LIBRARY_KINDS,
  rootLabel: 'Library',
  rootHref: '/org/node-library',
  folderHref: (nodes, id) => buildLibraryCategoryPath(nodes, id),
  placeholder: 'Search the library',
  chips: { courses: 'Items', folders: 'Folders' },
  noun: 'library items',
  platforms: false,
  icons: { Folder: IconCategory, 'Library item': IconLibrary },
  href: (nodes, node) => (node.datatype === 'NODE_LIBRARY_CATEGORY' ? buildLibraryCategoryPath(nodes, node.id) : buildLibraryPath(nodes, node.id))
}

// A row of the area that has a format (a course or template; not a folder,
// not a video, not a library item).
export const hasFormat = area => row => {
  const kind = area.kinds[(row.datatype || '').toUpperCase()]
  return !!kind && kind.kind === 'course' && !kind.video && area.platforms
}
